import React, {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import {FormError, FormHint, FormLabel, FormRow} from './Layout';

interface ITextInputProps {
  name: string;
  label?: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  hint?: React.ReactNode;
}

export const FIELD_CLASSES =
  'h-9 w-full rounded-md border border-[#dcdee5] bg-white px-3 text-[13px] text-[#33364b] outline-none transition-colors placeholder:text-gray-400 focus:border-[#654dcb] disabled:bg-[#f7f7f9] disabled:text-gray-400 aria-[invalid=true]:border-[#c2410c]';

export const TextInput: FC<ITextInputProps> = ({label, name, type = 'text', placeholder, disabled, required, hint}) => {
  const form = useFormContext();
  const error = form.formState.errors[name];

  return (
    <FormRow>
      {label && (
        <FormLabel htmlFor={`field-${name}`}>
          {label}
          {required && <span className="ml-0.5 text-[#c2410c]">*</span>}
        </FormLabel>
      )}

      <input
        id={`field-${name}`}
        type={type}
        disabled={disabled}
        required={required}
        {...form.register(name)}
        placeholder={placeholder}
        aria-invalid={error !== undefined ? 'true' : 'false'}
        className={FIELD_CLASSES}
      />
      {hint && !error && <FormHint>{hint}</FormHint>}
      {error && <FormError role="alert">{String(error.message)}</FormError>}
    </FormRow>
  );
};
